import { render, staticRenderFns } from "./QuoteRequestTypeDialog.vue?vue&type=template&id=85f23a1a&scoped=true&"
import script from "./QuoteRequestTypeDialog.vue?vue&type=script&lang=ts&"
export * from "./QuoteRequestTypeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteRequestTypeDialog.vue?vue&type=style&index=0&id=85f23a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f23a1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
